import { __assign } from 'tslib';
import React__default, { useState, useEffect } from 'react';
import { MenuItem, Slide, Box, Typography, IconButton } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import DefaultIcon from '../../../DefaultIcon/index.js';

var FolderItem = function (_a) {
    var folder = _a.folder, onSelectFolder = _a.onSelectFolder, onGoToChildren = _a.onGoToChildren, showElementCount = _a.showElementCount, _b = _a.KIcon, KIcon = _b === void 0 ? DefaultIcon : _b, _c = _a.testId, testId = _c === void 0 ? "FolderItem" : _c, className = _a.className, _d = _a.id, id = _d === void 0 ? "FolderItem" : _d, style = _a.style, sx = _a.sx, navigationDown = _a.navigationDown, isFirstItem = _a.isFirstItem;
    var t = useTranslation("refront-components").t;
    var _e = useState(true), startNavAnimation = _e[0], setStartNavAnimation = _e[1];
    var _f = useState(navigationDown), isNavigationDown = _f[0], setIsNavigationDown = _f[1];
    var _g = useState(isNavigationDown ? "left" : "right"), navAnimationDirection = _g[0], setNavAnimationDirection = _g[1];
    useEffect(function () {
        setIsNavigationDown(isNavigationDown);
    }, [isNavigationDown]);
    var handleStartNavAnimation = function (direction) {
        setNavAnimationDirection(direction);
        setStartNavAnimation(function (prev) { return !prev; });
    };
    var handleAnimationEnd = function () {
        setStartNavAnimation(function (prev) { return !prev; }); // Reset animation state
    };
    return (React__default.createElement(MenuItem
    // eslint-disable-next-line jsx-a11y/no-autofocus
    , { 
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus: isFirstItem, value: folder.id, className: clsx("FolderItem", className), "data-testid": testId, id: id, style: style, "aria-label": "Select ".concat(folder.title), sx: __assign({ width: "100%", padding: function (theme) { return theme.spacing(0, 1, 0, 1); }, height: function (theme) { return theme.spacing(4.5); }, minHeight: function (theme) { return theme.spacing(4.5); }, maxHeight: function (theme) { return theme.spacing(4.5); } }, sx), onClick: function () { return onSelectFolder(folder); }, onKeyDown: function (e) {
            if (e.key === "ArrowRight") {
                onGoToChildren(e, folder);
            }
        } },
        React__default.createElement(Slide, { "data-testid": "FilterFolderSlide", direction: navAnimationDirection, "in": startNavAnimation, appear: true, onExited: handleAnimationEnd, exit: false, timeout: 400 },
            React__default.createElement(Box, { sx: {
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                } },
                React__default.createElement(Box, { title: "".concat(t("filter.folder.select"), " \"").concat(folder.title, "\""), sx: {
                        maxWidth: "calc(100% - 34px)",
                        display: "flex",
                        gap: function (theme) { return theme.spacing(0.5); }
                    } },
                    React__default.createElement(Typography, { sx: {
                            fontSize: "0.875rem",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis"
                        } }, folder.title),
                    showElementCount && (React__default.createElement(Typography, { sx: {
                            fontSize: "0.875rem",
                            color: "rgba(0,0,0,0.5)",
                            paddingRight: !folder.hasChildren ? function (theme) { return theme.spacing(1); } : 0
                        } },
                        "(",
                        folder.treeMediaCount,
                        ")"))),
                folder.hasChildren && (React__default.createElement(IconButton, { "data-testid": "goToChildren", "aria-label": "".concat(t("filter.folder.go.to"), " \"").concat(folder.title, "\""), title: "".concat(t("filter.folder.go.to"), " \"").concat(folder.title, "\""), onClick: function (e) {
                        onGoToChildren(e, folder);
                        handleStartNavAnimation("left");
                    }, sx: { padding: function (theme) { return theme.spacing(0.875); } } },
                    React__default.createElement(KIcon, { className: "fa-solid fa-arrow-right", sx: {
                            fontSize: function (theme) { return theme.spacing(1.75); },
                            color: "rgba(0,0,0,0.6)"
                        } })))))));
};

export { FolderItem as default };
//# sourceMappingURL=index.js.map
